export enum HotType {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Season = "Season",
  Year = "Year",
  All = "All",
}